import {AuthModel} from './_models'
import {setHeaderToken} from "../../../services/api";
import {AUTH_LS_KEY} from "../../../mock/constants";

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LS_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      setHeaderToken(auth.access)
      return auth
    }
  } catch (error) {
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LS_KEY, lsValue)
  } catch (error) {
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LS_KEY)
  } catch (error) {
  }
}

export {getAuth, setAuth, removeAuth, AUTH_LS_KEY}
